var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 154,
    viewBox: "0 0 273 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9297 97.1484H40.7497",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 90.8881C6.26 92.6281 7.67 94.0481 9.42 94.0481C10.26 94.0481 11.02 93.7181 11.59 93.1881C12.2 92.6081 12.58 91.7981 12.58 90.8881V90.8681C12.58 87.3981 9.76 84.5781 6.29 84.5781C2.82 84.5781 0 87.3981 0 90.8681C0 94.3381 2.82 97.1581 6.29 97.1581H22.27",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.42 13.8828L0 13.9928",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0816 7.31V7.29C38.0816 3.82 40.9016 1 44.3716 1C47.8416 1 50.6616 3.82 50.6616 7.29C50.6616 10.76 47.8416 13.58 44.3716 13.58L20.1016 13.8",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.568 125.651C242.568 128.001 244.468 129.901 246.818 129.901C247.948 129.901 248.968 129.461 249.738 128.741C250.558 127.961 251.078 126.861 251.078 125.641V125.611C251.078 120.931 247.288 117.141 242.608 117.141C237.928 117.141 234.138 120.931 234.138 125.611C234.138 130.291 237.928 134.081 242.608 134.081H225.648",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.084 37.9688H211.094",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.301 19.21C271.251 15.07 267.501 12 263.041 12C260.111 12 257.481 13.32 255.721 15.4C254.311 17.07 253.471 19.22 253.471 21.57C253.471 21.77 253.491 21.97 253.501 22.17C252.551 21.78 251.511 21.57 250.421 21.57C245.891 21.57 242.221 25.24 242.221 29.77C242.221 34.3 245.891 37.97 250.421 37.97H230.781",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1506 53.6997C48.2607 53.6997 49.1606 52.7998 49.1606 51.6897C49.1606 50.5796 48.2607 49.6797 47.1506 49.6797C46.0405 49.6797 45.1406 50.5796 45.1406 51.6897C45.1406 52.7998 46.0405 53.6997 47.1506 53.6997Z",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 90.5312H231.367",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.93 92.0788V88.9688",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6178 137.969H65.5078",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0703 139.532V136.422",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0403 56.7422H37.8203",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9297 59.8528V53.6328",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232.931 96.2891H226.711",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M229.82 99.3997V93.1797",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.969 147.581C131.149 156.241 149.919 154.441 162.189 142.171C175.669 128.691 176.509 107.351 164.719 92.8906",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.887 150.972L112.867 144.672L119.827 145.212L115.887 150.972Z",
    fill: "#2866A9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.781 100.539C97.0706 112.769 98.4406 127.489 106.911 138.519",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.767 92.6562C107.117 93.4362 106.507 94.2362 105.938 95.0562",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.637 85.5391C114.687 86.1791 113.767 86.8591 112.867 87.5991",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.353 84.1128C144.223 78.3528 131.943 77.7728 121.383 82.3928",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.353 80.6797L158.542 86.8897L151.562 86.5497L155.353 80.6797Z",
    fill: "#2866A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.914 128.305C137.764 128.645 137.564 128.945 137.314 129.195C137.064 129.445 136.764 129.645 136.424 129.785C136.074 129.925 135.704 129.995 135.324 129.995C134.944 129.995 134.554 129.925 134.204 129.785C133.854 129.645 133.554 129.445 133.294 129.195C133.034 128.945 132.844 128.655 132.694 128.305C132.554 127.965 132.484 127.595 132.484 127.195C132.484 126.795 132.554 126.445 132.694 126.095C132.834 125.745 133.034 125.445 133.294 125.195C133.554 124.945 133.854 124.745 134.204 124.595C134.554 124.445 134.924 124.375 135.324 124.375C135.724 124.375 136.074 124.455 136.424 124.595C136.774 124.745 137.074 124.945 137.314 125.195C137.554 125.445 137.764 125.745 137.914 126.095C138.064 126.445 138.134 126.815 138.134 127.195C138.134 127.575 138.064 127.965 137.914 128.305Z",
    fill: "#CF1C4E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.941 111.248C142.671 111.938 142.321 112.538 141.901 113.048C141.481 113.558 141.031 113.998 140.551 114.378C140.061 114.748 139.601 115.108 139.171 115.428C138.731 115.758 138.361 116.078 138.041 116.398C137.721 116.718 137.531 117.078 137.471 117.468L137.041 120.198H133.881L133.561 117.148C133.551 117.088 133.541 117.038 133.541 116.988V116.828C133.541 116.278 133.681 115.808 133.951 115.398C134.221 114.998 134.571 114.618 134.981 114.258C135.391 113.898 135.831 113.558 136.311 113.218C136.781 112.878 137.231 112.518 137.641 112.128C138.051 111.738 138.391 111.288 138.671 110.798C138.951 110.308 139.081 109.718 139.081 109.038C139.081 108.588 138.991 108.188 138.831 107.838C138.661 107.478 138.431 107.178 138.131 106.918C137.831 106.658 137.471 106.468 137.051 106.328C136.631 106.188 136.181 106.128 135.701 106.128C134.991 106.128 134.391 106.208 133.901 106.358C133.411 106.518 132.991 106.688 132.651 106.878C132.311 107.068 132.021 107.248 131.781 107.398C131.541 107.558 131.331 107.628 131.141 107.628C130.691 107.628 130.371 107.438 130.171 107.068L128.961 105.138C129.381 104.768 129.851 104.408 130.351 104.078C130.861 103.738 131.401 103.448 131.991 103.198C132.581 102.948 133.211 102.748 133.901 102.608C134.581 102.468 135.331 102.398 136.121 102.398C137.201 102.398 138.191 102.548 139.081 102.848C139.971 103.148 140.731 103.578 141.371 104.128C142.001 104.678 142.501 105.348 142.841 106.138C143.191 106.918 143.361 107.798 143.361 108.768C143.361 109.738 143.221 110.538 142.951 111.228L142.941 111.248Z",
    fill: "#CF1C4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.8be8144aaf2ec84135db9999fa8fc83d.svg";
export { ForwardRef as ReactComponent };